function a(r) {
  return r.split("");
}
var i = a;
export {
  i as _
};
//# sourceMappingURL=_asciiToArray.js.map
